import React from 'react'
import CloseBillPayCard from 'src/app/CloseBillPayCard/CloseBillPayCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { closeBillPayCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CloseBillPayCardAppRoute: AppRoute = {
  id: AppLocation.CloseBillPayCard,
  routeProps: closeBillPayCardRouteProps,
  component: <CloseBillPayCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CloseBillPayCardAppRoute
